import { useState, useEffect } from 'react'
import { getTrainingStatusActiveAPI } from '../services/certificate'

function UseStatusActive() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingStatusActiveAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.t_status }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseStatusActive
